import React, { Component } from 'react';
import '../css/topNav.css';
import { Link } from 'react-router-dom';

export default class SideNav extends Component {
    render() {
        return (
            <div>
            <nav id="sidebarMenu" class="collapse d-lg-block sidebar collapse bg-white">
              <div class="position-sticky">
                <div class="list-group list-group-flush mx-3 mt-4">
                  <Link to="/" class="list-group-item list-group-item-action py-2 ripple active" aria-current="true">
                    <i class="fas fa-tachometer-alt fa-fw me-3"></i><span>Main dashboard</span>
                  </Link>
                  <Link to="/about" class="list-group-item list-group-item-action py-2 ripple ">
                    <i class="fas fa-chart-area fa-fw me-3"></i><span>About</span>
                  </Link>
                  <Link to="/location" class="list-group-item list-group-item-action py-2 ripple ">
                    <i class="fas fa-chart-area fa-fw me-3"></i><span>Hospital Location</span>
                  </Link>
                  <Link to="/doctor-name" class="list-group-item list-group-item-action py-2 ripple ">
                    <i class="fas fa-chart-area fa-fw me-3"></i><span>Doctor Name</span>
                  </Link>
                  <Link to="/contact" class="list-group-item list-group-item-action py-2 ripple"><i
                      class="fas fa-lock fa-fw me-3"></i><span>contact</span></Link>
                  
                </div>
              </div>
            </nav>
            
                </div>
            
        )
    }
}
